<script>
import { computed, defineComponent, reactive, toRefs } from "vue";
// import { useI18n } from "vue-i18n";

import { get } from "@/utils/request";

export default defineComponent({
  props: {
    url: String,
    size: {
      type: Number,
      default: 20,
    },
    modelValue: String,
    searchKey: {
      type: String,
      required: true,
    },
    keyMap: Object,
  },
  setup(props, context) {
    const state = reactive({
      loading: false,
      data: [],
    });

    // const { t } = useI18n();

    const propMap = computed(() => {
      let map = props.keyMap ? { ...props.keyMap } : {};
      if (!map["label"]) {
        map.label = "label";
      }
      if (!map["value"]) {
        map.value = "value";
      }

      return map;
    });

    const reset = () => {
      state.data = [];
    };

    const getList = async (query) => {
      if (!query) {
        state.data = [];
        return;
      }

      try {
        state.loading = true;

        const params = {
          size: props.size,
        };
        params[props.searchKey] = query;

        const { data } = await get(props.url, params);
        state.data = data;
      } catch (error) {
        state.data = [];
        console.log(error);
      } finally {
        state.loading = false;
      }
    };
    // events
    const onChange = (value) => {
      if (value === "") {
        value = undefined;
      }
      context.emit("update:modelValue", value);
    };

    return {
      ...toRefs(state),
      propMap,
      getList,
      onChange,
      reset,
    };
  },
  render() {
    return (
      <el-select
        modelValue={this.modelValue}
        placeholder={this.$t("commonTipSelect")}
        filterable={true}
        remote={true}
        remote-method={this.getList}
        loading={this.loading}
        onChange={this.onChange}
        clearable
      >
        {this.data.map((item) => {
          return (
            <el-option
              key={item.value}
              value={item[this.propMap.value]}
              label={item[this.propMap.label]}
            ></el-option>
          );
        })}
      </el-select>
    );
  },
});
</script>
